import * as React from 'react';

import { Bike, CarFront, Footprints, Truck } from 'lucide-react';

import type { VehicleProfile } from '@klareospace/pharos-lib-types';

// ─── Constants ────────────────────────────────────────────────────────────────

export const PROFILE_ICON_MAP: Record<string, React.ElementType> = {
  bicycle: Bike,
  'large-vehicle': Truck,
  'lightweight-vehicle': CarFront,
  pedestrian: Footprints,
};

// ─── Types ────────────────────────────────────────────────────────────────────

interface VehicleProfileIconProps {
  className?: string;
  profile: VehicleProfile | string;
  size?: number;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function VehicleProfileIcon({ className, profile, size = 16 }: VehicleProfileIconProps): React.JSX.Element {
  const Icon = PROFILE_ICON_MAP[profile] ?? CarFront;
  return <Icon className={className} size={size} />;
}
